import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../../http/clients/api';
import { Subject, Observable } from 'rxjs';
import { OfferOption } from '../../models/dto/offer-option/offer-option.model';
import { environment } from 'environments/environment';
import { Offer } from './offer.model';

@Injectable({
  providedIn: 'root'
})
export class OffersService {
  offerOption: Observable<OfferOption>;
  offer: Observable<Offer>;

  private offerOptionSource: Subject<OfferOption> = new Subject<OfferOption>();
  private offerSource: Subject<Offer> = new Subject<Offer>();

  constructor(private http: ApiHttpClient) {
    this.offerOption = this.offerOptionSource.asObservable();
    this.offer = this.offerSource.asObservable();
  }

  getDealOffers(borrowerId: number): Observable<Offer[]> {
    return this.http.get<Offer[]>(`${environment.API_URL}/offer`, {
      params: {
        query: JSON.stringify({
          criteria: {
            'deals.borrowerId': { '==': borrowerId }
          }
        })
      }
    });
  }

  create(offer: Offer): Observable<Offer> {
    return this.http.post<Offer>(`${environment.API_URL}/offer`, offer);
  }

  update(offerId: number, updates: any): Observable<Offer> {
    return this.http.put<Offer>(`${environment.API_URL}/offer/${offerId}`, updates);
  }

  delete(offerId: number): Observable<Offer> {
    return this.http.delete<Offer>(`${environment.API_URL}/offer/${offerId}`);
  }

  getOfferOptionsByBorrowerId(borrowerId: number): Observable<OfferOption[]> {
    return this.http.get<OfferOption[]>(`${environment.API_URL}/borrower/${borrowerId}/offer-options`);
  }

  emitOfferOption(offerOption: OfferOption) {
    this.offerOptionSource.next(offerOption);
  }

  emitOffer(offer: Offer) {
    this.offerSource.next(offer);
  }

  createOfferOption(dealId: number, offerOptionData: object): Observable<OfferOption> {
    return this.http.post<OfferOption>(`${environment.API_URL}/deals/${dealId}/offer-options/`, offerOptionData);
  }

  updateOfferOptionTerms(dealId: number, offerOptionId: number, termSetData: object): Observable<any> {
    const postData = {
      termSetData
    };
    return this.http.put(`${environment.API_URL}/deals/${dealId}/offer-options/${offerOptionId}/term-set`, postData);
  }

  deleteOfferOption(dealId: number, offerOptionId: number): Observable<OfferOption[]> {
    return this.http.delete<OfferOption[]>(`${environment.API_URL}/deals/${dealId}/offer-options/${offerOptionId}`);
  }

  patchOfferOptionStatus(dealId: number, offerOptionId: number, status: string): Observable<any> {
    const postData = {
      status
    };
    return this.http.patch(`${environment.API_URL}/deals/${dealId}/offer-options/${offerOptionId}`, postData);
  }

  aggregateOfferOptionRelationships(offerOptions, deals, approvals, offers): OfferOption[] | null {
    offerOptions?.forEach((offerOption, index) => {
      if(deals?.length > 0){
        const parentDealIndex = deals.findIndex(d => d.id === offerOption.dealId);
        offerOptions[index].deal = deals[parentDealIndex];
      }
      if(approvals?.length > 0 && offerOption.approvalId){
        const parentApprovalIndex = approvals?.findIndex(a => a.id === offerOption.approvalId);
        offerOptions[index].approval = approvals[parentApprovalIndex];
      }
      if(offers?.length > 0 && offerOption.offerId){
        const parentOfferIndex = offers.findIndex(o => o.id === offerOption.offerId);
        offerOptions[index].offer = offers[parentOfferIndex];
      }
    });
    return offerOptions;
  }
}
